declare const posthog: any;
import Cars4SalePage from "./cars4-sale-page"
import { getCreditUnionGroups } from './posthog-group'

const yearSectionEl = document.getElementById('year-section')
const loanCalculatorApplyEl = document.getElementById('loan-calculator-apply')
const searchButton = document.querySelectorAll('.js-filters-search')
const financeRateInputEl = document.getElementById('custom-apr-display') as HTMLInputElement | null
const financeRateLabelEl = document.getElementById('custom-apr-display-label')
const financeRateRequiredEl = document.getElementById('custom-apr-required')
const appliedFiltersRowEl = document.getElementById('applied-filters-row')
const appliedFiltersListEl = document.getElementById('applied-filters-list')
const clearAllFiltersEl = document.getElementById('clear-all-filters')
const sortSelectEl = document.querySelector<HTMLSelectElement>('select[name="SortBy"]')
const pageHeadingEl = document.getElementById('page-heading')
const pageIntroEl = document.getElementById('page-intro')
const inventoryPaginationContainerEl = document.getElementById('inventory-pagination-container')
const inventoryResultsRegionEl = document.getElementById('inventory-results-region')
const inventoryLoadingIndicatorEl = document.getElementById('inventory-loading-indicator')
const inventoryCarsContainerEl = document.getElementById('loadcars')
let isFilterRefreshInProgress = false
const filtersFormEl = Cars4SalePage.filtersForm
const hasFiltersForm = filtersFormEl instanceof HTMLFormElement

type AppliedFilterChip = {
    field: string
    label: string
    value?: string
    make?: string
    model?: string
}

type RefreshDataOptions = {
    skipFinanceRatePrompt?: boolean
    targetPage?: number
    skipFilterCounts?: boolean
    pushHistory?: boolean
}

if (window.location.pathname.indexOf('/cars-for-sale') > -1 && hasFiltersForm) {
    toggleFilterOptionsVisibility()
    updateFilterSummaries()
    updateAppliedFilterChips()
    syncBrowserUrl()

    window.addEventListener('popstate', () => {
        window.location.assign(window.location.href)
    })

    window.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && document.body.classList.contains('has-open-filters')) {
            closeFilters()
        }
    })
    
    // Input Handlers
    document.addEventListener('change', async (event) => {
        let p = event.target
        let input = ((p as HTMLElement).closest('#filters-form input, #filters-form select') as HTMLInputElement | HTMLSelectElement | null)

        // If input in the filter form was changed
        if (isFilterRefreshInProgress) return

        if (input && input.disabled === false) {
            updateFilterSummaries()
            updateAppliedFilterChips()
            await refreshData(input, { skipFilterCounts: input.name === 'SortBy' })
        }
    })

    searchButton?.forEach(item => {
        item.addEventListener('click', async (event) => {
            event.preventDefault()
            if (isFilterRefreshInProgress) return
            const refreshed = await refreshData(null)
            if (refreshed) {
                closeFilters()
                scrollResultsIntoView()
            }
        })
    })

    loanCalculatorApplyEl?.addEventListener('click', async () => {
        if (isFilterRefreshInProgress) return

        if (hasFinanceRate() === false) {
            setFinanceRateRequiredState(true)
            return
        }

        await refreshData(null)
    })

    document.addEventListener('click', function (event) {
        let el = event.target as HTMLElement;
        const filters = document.querySelectorAll<HTMLElement>('.js-filters');
        
        // Check for clicks on filtersClose elements
        if (el.closest('.js-filters-close')) {
            event.preventDefault();
            closeFilters()
            return
        }

        if (el.closest('.js-filters-backdrop')) {
            event.preventDefault();
            closeFilters()
            return
        }

        const paginationLink = el.closest<HTMLElement>('[data-page-link]')
        if (paginationLink) {
            event.preventDefault()
            if (isFilterRefreshInProgress) return

            const targetPage = Number(paginationLink.getAttribute('data-page-number') ?? '')
            if (Number.isFinite(targetPage) && targetPage > 0) {
                if (typeof posthog !== 'undefined') {
                    posthog.capture('pagination_clicked', {
                        page_number: targetPage,
                        $groups: getCreditUnionGroups(),
                    });
                }

                void refreshData(null, {
                    targetPage,
                    skipFilterCounts: true,
                    pushHistory: true
                })
            }

            return
        }

        // Check for clicks on filtersTrigger elements
        if (el.closest('.js-filters-trigger')) {
            event.preventDefault();
            openFilters(filters)
        }

        const chipRemoveButton = el.closest<HTMLElement>('[data-filter-chip-remove]')
        if (chipRemoveButton) {
            event.preventDefault()
            if (isFilterRefreshInProgress) return
            void removeAppliedFilterChip(chipRemoveButton)
            return
        }

        if (el.closest('#clear-all-filters')) {
            event.preventDefault()
            if (isFilterRefreshInProgress) return
            if (typeof posthog !== 'undefined') {
                posthog.capture('filter_cleared', { filter_type: 'all', $groups: getCreditUnionGroups() });
            }
            clearAllShopperFilters()
            updateFilterSummaries()
            updateAppliedFilterChips()
            void refreshData(null, { skipFinanceRatePrompt: true })
            return
        }

        // Handling click outside of .js-filters-content to close the filter
        //if (!el.closest('.js-filters-content')) {
        //    filters.forEach((filter) => {
        //        if (filter.classList.contains('is-active')) {
        //            filter.classList.remove('is-active');
        //            document.body.classList.remove('has-open-filters');
        //        }
        //    });
        //}
    });
}

function openFilters(filters = document.querySelectorAll<HTMLElement>('.js-filters')) {
    filters.forEach((filter) => {
        filter.classList.remove('hidden')
        filter.classList.add('is-active')
    })

    document.body.classList.add('has-open-filters')
}

function closeFilters() {
    document.querySelectorAll<HTMLElement>('.js-filters').forEach((filter) => {
        filter.classList.remove('is-active')
        filter.classList.add('hidden')
    })

    document.body.classList.remove('has-open-filters')
}

function setElementBusyState(element: HTMLElement, isBusy: boolean) {
    if ('disabled' in element) {
        const formElement = element as HTMLInputElement | HTMLSelectElement | HTMLButtonElement | HTMLTextAreaElement
        const previousDisabled = formElement.disabled

        if (isBusy) {
            formElement.dataset.busyWasDisabled = previousDisabled ? 'true' : 'false'
            formElement.disabled = true
        } else {
            formElement.disabled = formElement.dataset.busyWasDisabled === 'true'
            delete formElement.dataset.busyWasDisabled
        }
    } else {
        element.classList.toggle('pointer-events-none', isBusy)
        element.classList.toggle('opacity-60', isBusy)
        element.setAttribute('aria-disabled', isBusy ? 'true' : 'false')
    }
}

function setFilterBusyState(isBusy: boolean) {
    isFilterRefreshInProgress = isBusy
    Cars4SalePage.filterRefreshInProgress = isBusy
    setResultsLoadingState(isBusy)

    document.querySelectorAll<HTMLElement>('#filters-form input, #filters-form select, #filters-form button').forEach(element => {
        setElementBusyState(element, isBusy)
    })

    document.querySelectorAll<HTMLElement>('#applied-filters-row button').forEach(element => {
        setElementBusyState(element, isBusy)
    })

    searchButton.forEach(element => {
        setElementBusyState(element as HTMLElement, isBusy)
    })

    if (loanCalculatorApplyEl)
        setElementBusyState(loanCalculatorApplyEl, isBusy)

    if (sortSelectEl)
        setElementBusyState(sortSelectEl, isBusy)
}

function setResultsLoadingState(isBusy: boolean) {
    inventoryResultsRegionEl?.setAttribute('aria-busy', isBusy ? 'true' : 'false')

    inventoryLoadingIndicatorEl?.classList.toggle('hidden', !isBusy)
    inventoryLoadingIndicatorEl?.classList.toggle('flex', isBusy)

    inventoryCarsContainerEl?.classList.toggle('opacity-40', isBusy)
    inventoryPaginationContainerEl?.classList.toggle('opacity-40', isBusy)
    appliedFiltersRowEl?.classList.toggle('opacity-60', isBusy)
}

async function refreshData(cb: HTMLInputElement | HTMLSelectElement | null, options: RefreshDataOptions = {}): Promise<boolean> {
    if (isFilterRefreshInProgress) return false

    const skipFinanceRatePrompt = options.skipFinanceRatePrompt === true
    const shouldSkipFilterCounts = options.skipFilterCounts === true
    const targetPage = options.targetPage && options.targetPage > 0 ? Math.floor(options.targetPage) : 1

    if (skipFinanceRatePrompt === false && requiresFinanceRatePrompt(cb) && hasFinanceRate() === false) {
        setFinanceRateRequiredState(true)
        updateFilterSummaries()
        updateAppliedFilterChips()
        return false
    } else if (hasFinanceRate()) {
        setFinanceRateRequiredState(false)
    }

    setCurrentResultsPage(targetPage)
    const formData = buildFilterFormData(shouldSkipFilterCounts)
    const queryParams = getFilterQueryParams(formData)
    setFilterBusyState(true)

    try {
        let data = await getFilterData(formData)

        // Load Models
        if (cb instanceof HTMLInputElement && cb.name == 'Make') {
            await handleMakeChange(cb, data, queryParams)
        }

        // Load Trims
        if (cb instanceof HTMLInputElement && cb.name == 'Model') {
            await handleModelChange(cb, data, queryParams)
        }

        Cars4SalePage.refreshSlides(data)
        renderPagination(data)

        toggleYearSection()
        toggleNoResults(data.totalCount)

        // PostHog: filter_applied (skip SortBy and Zip — tracked separately)
        if (cb && cb.name !== 'SortBy' && cb.name !== 'Zip' && typeof posthog !== 'undefined') {
            posthog.capture('filter_applied', {
                filter_type: cb.name,
                filter_value: cb.value,
                results_count: data?.totalCount ?? undefined,
                $groups: getCreditUnionGroups(),
            });
        }

        // PostHog: sort_changed
        if (cb && cb.name === 'SortBy' && typeof posthog !== 'undefined') {
            posthog.capture('sort_changed', {
                sort_by: cb.value,
                $groups: getCreditUnionGroups(),
            });
        }

        // PostHog: search_zip_changed
        if (cb && cb.name === 'Zip' && typeof posthog !== 'undefined') {
            posthog.capture('search_zip_changed', {
                zip_code: cb.value,
                radius: document.querySelector<HTMLInputElement>('#filters-form input[name="Radius"]')?.value?.trim() || undefined,
                results_count: data?.totalCount ?? undefined,
                $groups: getCreditUnionGroups(),
            });
        }

        // PostHog: no_results_shown
        if (data.totalCount === 0 && typeof posthog !== 'undefined') {
            const activeFilters: Record<string, string[]> = {};
            document.querySelectorAll<HTMLInputElement>('#filters-form input:checked').forEach(input => {
                if (!activeFilters[input.name]) activeFilters[input.name] = [];
                activeFilters[input.name].push(input.value);
            });
            const zipVal = document.querySelector<HTMLInputElement>('#filters-form input[name="Zip"]')?.value?.trim();
            if (zipVal) activeFilters['Zip'] = [zipVal];

            posthog.capture('no_results_shown', {
                active_filters: activeFilters,
                $groups: getCreditUnionGroups(),
            });
        }

        if (shouldSkipFilterCounts === false) {
            updateCounts(data)
        }

        updateSeoContent(data)
        updateFilterSummaries()
        updateAppliedFilterChips()
        setCurrentResultsPage(data?.currentPage ?? 1)
        syncBrowserUrl(options.pushHistory === true)

        if (document.body.classList.contains('has-open-filters') === false) {
            scrollResultsIntoView()
        }

        return true
    } finally {
        setFilterBusyState(false)
    }
}

function updateCounts(data: any) {
    const getValue = (item: any, ...keys: string[]) => {
        for (const key of keys) {
            if (item?.[key] !== undefined && item?.[key] !== null) return item[key]
        }

        return ''
    }

    const getCount = (item: any) => {
        const value = getValue(item, 'count', 'Count')
        return Number.isFinite(Number(value)) ? Number(value) : 0
    }

    document.querySelectorAll<HTMLElement>(`[data-name]`)?.forEach(item => item.innerHTML = '(0)')

    data.conditions?.forEach((item: any) => {
        const value = getValue(item, 'value', 'Value')
        let el = document.querySelector(`[data-name=Condition][data-value="${escapeSelector(String(value))}"]`)
        if (el) el.innerHTML = '(' + getCount(item) + ')'
    })

    data.bodyTypes?.forEach((item: any) => {
        const value = getValue(item, 'value', 'Value')
        let el = document.querySelector(`[data-name=BodyType][data-value="${escapeSelector(String(value))}"]`)
        if (el) el.innerHTML = '(' + getCount(item) + ')'
    })

    data.makes?.forEach((item: any) => {
        const value = getValue(item, 'value', 'Value')
        let el = document.querySelector(`[data-name=Make][data-value="${escapeSelector(String(value))}"]`)
        if (el) el.innerHTML = '(' + getCount(item) + ')'
    })

    data.makeModels?.forEach((item: any) => {
        const make = String(getValue(item, 'make', 'Make'))
        const model = String(getValue(item, 'model', 'Model'))
        let el = document.querySelector(`[data-name=Model][data-make="${escapeSelector(make)}"][data-value="${escapeSelector(model)}"]`)
        if (el) el.innerHTML = '(' + getCount(item) + ')'
    })

    data.makeModelTrims?.forEach((item: any) => {
        const make = String(getValue(item, 'make', 'Make'))
        const model = String(getValue(item, 'model', 'Model'))
        const trim = String(getValue(item, 'trim', 'Trim'))
        let el = document.querySelector(`[data-name=Trim][data-make="${escapeSelector(make)}"][data-model="${escapeSelector(model)}"][data-value="${escapeSelector(trim)}"]`)
        if (el) el.innerHTML = '(' + getCount(item) + ')'
    })

    data.colors?.forEach((item: any) => {
        const value = getValue(item, 'value', 'Value')
        let el = document.querySelector(`[data-name=Color][data-value="${escapeSelector(String(value))}"]`)
        if (el) el.innerHTML = '(' + getCount(item) + ')'
    })

    data.drivetrains?.forEach((item: any) => {
        const value = getValue(item, 'value', 'Value')
        let el = document.querySelector(`[data-name=Drivetrain][data-value="${escapeSelector(String(value))}"]`)
        if (el) el.innerHTML = '(' + getCount(item) + ')'
    })

    data.fuelTypes?.forEach((item: any) => {
        const value = getValue(item, 'value', 'Value')
        let el = document.querySelector(`[data-name=EngineFuelType][data-value="${escapeSelector(String(value))}"]`)
        if (el) el.innerHTML = '(' + getCount(item) + ')'
    })

    data.transmissions?.forEach((item: any) => {
        const value = getValue(item, 'value', 'Value')
        let el = document.querySelector(`[data-name=Transmission][data-value="${escapeSelector(String(value))}"]`)
        if (el) el.innerHTML = '(' + getCount(item) + ')'
    })

    toggleFilterOptionsVisibility()

    updateInventoryOptionVisibility('Make', data.makes, (item) => ({
        value: String(getValue(item, 'value', 'Value'))
    }))
    updateInventoryOptionVisibility('Model', data.makeModels, (item) => ({
        value: String(getValue(item, 'model', 'Model')),
        make: String(getValue(item, 'make', 'Make'))
    }))
    updateInventoryOptionVisibility('Trim', data.makeModelTrims, (item) => ({
        value: String(getValue(item, 'trim', 'Trim')),
        make: String(getValue(item, 'make', 'Make')),
        model: String(getValue(item, 'model', 'Model'))
    }))
}

function renderPagination(data: any) {
    if (!inventoryPaginationContainerEl) return

    const paginationHtml = typeof data?.paginationHtml === 'string' ? data.paginationHtml : ''
    inventoryPaginationContainerEl.innerHTML = paginationHtml
}

function scrollResultsIntoView() {
    if (inventoryResultsRegionEl) {
        inventoryResultsRegionEl.scrollIntoView({ behavior: 'smooth', block: 'start' })
        return
    }

    window.scrollTo({ top: 0, behavior: 'smooth' })
}

function updateInventoryOptionVisibility(
    name: string,
    items: any[] | undefined,
    getKeyParts: (item: any) => { value: string, make?: string, model?: string }
) {
    const available = new Set<string>()

    items?.forEach(item => {
        const parts = getKeyParts(item)
        available.add([
            parts.make?.toLowerCase() ?? '',
            parts.model?.toLowerCase() ?? '',
            parts.value.toLowerCase()
        ].join('|'))
    })

    document.querySelectorAll<HTMLElement>(`[data-filter-option][data-filter-name="${name}"]`).forEach(optionEl => {
        const input = optionEl.querySelector<HTMLInputElement>(`input[name="${name}"]`)
        if (!input) return

        const optionKey = [
            (input.getAttribute('data-make') ?? '').toLowerCase(),
            (input.getAttribute('data-model') ?? '').toLowerCase(),
            (input.value ?? '').toLowerCase()
        ].join('|')

        const shouldShow = input.checked || available.has(optionKey)
        optionEl.classList.toggle('hidden', !shouldShow)
    })
}

function buildFilterFormData(skipFilterCounts = false) {
    if (!hasFiltersForm) {
        return new FormData()
    }

    let parms = new FormData(filtersFormEl)
    parms.set('SkipFilterCounts', skipFilterCounts ? 'true' : 'false')
    parms.delete('IdCSV')
    return parms
}

async function getFilterData(parms = buildFilterFormData()) {
    const response = await fetch('/cars-for-sale?handler=LoadPage', { method: 'POST', body: parms })
    let data = await response.json()

    return data;
}

function getFilterQueryParams(formData = hasFiltersForm ? new FormData(filtersFormEl) : new FormData()) {
    const params = new URLSearchParams()
    formData.forEach((value, key) => {
        params.append(key, value.toString())
    })

    return params
}

function getCurrentResultsPage() {
    const pageValue = document.querySelector<HTMLInputElement>('#filters-form input[name="page"]')?.value ?? ''
    const pageNumber = Number(pageValue)
    return Number.isFinite(pageNumber) && pageNumber > 0 ? Math.floor(pageNumber) : 1
}

function setCurrentResultsPage(pageNumber: number) {
    const pageInput = document.querySelector<HTMLInputElement>('#filters-form input[name="page"]')
    if (pageInput) pageInput.value = String(Math.max(1, pageNumber))
}

function appendCheckedParams(params: URLSearchParams, name: string) {
    document.querySelectorAll<HTMLInputElement>(`#filters-form input[name="${name}"]:checked`).forEach(input => {
        const value = input.value.trim()
        if (value.length > 0) params.append(name, value)
    })
}

function appendValueParam(params: URLSearchParams, key: string, value: string | null | undefined) {
    const normalizedValue = value?.trim() ?? ''
    if (normalizedValue.length > 0) params.append(key, normalizedValue)
}

function appendNumberParam(params: URLSearchParams, key: string, value: number | null) {
    if (value === null || Number.isNaN(value)) return
    params.append(key, String(value))
}

function buildPublicFilterQueryParams() {
    const params = new URLSearchParams()
    const zip = getInputTextValue('#filters-form input[name="Zip"]')
    const customApr = getInputTextValue('#custom-apr-display')
    const paymentCashDown = getNumericInputValue('#payment-cashdown-display')
    const paymentTerm = getActivePaymentTerm()
    const paymentMin = getNumericInputValue('#filters-form input[name="PaymentMin"]')
    const paymentMax = getNumericInputValue('#filters-form input[name="PaymentMax"]')
    const priceMin = getNumericInputValue('#filters-form input[name="PriceMin"]')
    const priceMax = getNumericInputValue('#filters-form input[name="PriceMax"]')
    const mileageSelect = document.querySelector<HTMLSelectElement>('#filters-form select[name="MileageMax"]')
    const mileageMax = mileageSelect?.value ? Number(mileageSelect.value) : null
    const yearMinInput = document.querySelector<HTMLInputElement>('#filters-form input[name="YearMin"]')
    const yearMaxInput = document.querySelector<HTMLInputElement>('#filters-form input[name="YearMax"]')
    const yearMin = yearMinInput?.value?.trim() ?? ''
    const yearMax = yearMaxInput?.value?.trim() ?? ''
    const sortValue = document.querySelector<HTMLInputElement>('#filters-form input[name="SortBy"]')?.value?.trim() ?? ''
    const showFavorites = document.querySelector<HTMLInputElement>('#filters-form input[name="ShowFavorites"]')?.value === 'true'
    const dealershipId = document.querySelector<HTMLInputElement>('#filters-form input[name="DealershipId"]')?.value?.trim() ?? ''
    const pageNumber = getCurrentResultsPage()

    appendValueParam(params, 'ShowFavorites', showFavorites ? 'true' : '')
    appendValueParam(params, 'DealershipId', dealershipId)
    appendValueParam(params, 'Zip', zip)
    appendCheckedParams(params, 'Condition')
    appendCheckedParams(params, 'BodyType')
    appendCheckedParams(params, 'Make')
    appendCheckedParams(params, 'Model')
    appendCheckedParams(params, 'Trim')
    appendCheckedParams(params, 'Color')
    appendCheckedParams(params, 'Drivetrain')
    appendCheckedParams(params, 'EngineFuelType')
    appendCheckedParams(params, 'Transmission')
    appendValueParam(params, 'CustomAPR', Number(customApr) > 0 ? customApr : '')
    appendNumberParam(params, 'PaymentCashDown', paymentCashDown !== null && paymentCashDown > 0 ? paymentCashDown : null)
    appendValueParam(params, 'PaymentTerm', paymentTerm)
    appendNumberParam(params, 'PaymentMin', paymentMin !== null && paymentMin > 0 ? paymentMin : null)
    appendNumberParam(params, 'PaymentMax', paymentMax !== null && paymentMax > 0 ? paymentMax : null)
    appendNumberParam(params, 'PriceMin', priceMin !== null && priceMin > 0 ? priceMin : null)
    appendNumberParam(params, 'PriceMax', priceMax !== null && priceMax > 0 ? priceMax : null)
    appendNumberParam(params, 'MileageMax', mileageMax !== null && mileageMax > 0 ? mileageMax : null)

    if (yearMin.length > 0 && yearMin !== (yearMinInput?.min ?? '')) appendValueParam(params, 'YearMin', yearMin)
    if (yearMax.length > 0 && yearMax !== (yearMaxInput?.max ?? '')) appendValueParam(params, 'YearMax', yearMax)
    if (sortValue.length > 0) appendValueParam(params, 'SortBy', sortValue)
    if (pageNumber > 1) appendValueParam(params, 'page', String(pageNumber))

    return params
}

function syncBrowserUrl(pushHistory = false) {
    const query = buildPublicFilterQueryParams().toString()
    const normalizedUrl = `${window.location.pathname}${query ? `?${query}` : ''}`
    const currentUrl = `${window.location.pathname}${window.location.search}`

    if (normalizedUrl !== currentUrl) {
        if (pushHistory) {
            window.history.pushState({}, '', normalizedUrl)
            // Track pagination as a pageview so PostHog sees in-page navigations
            if (typeof posthog !== 'undefined') {
                posthog.capture('$pageview', { $current_url: window.location.href })
            }
        } else {
            window.history.replaceState({}, '', normalizedUrl)
        }
    }
}

function updateSeoContent(data: any) {
    const pageHeading = typeof data?.pageHeading === 'string' ? data.pageHeading.trim() : ''
    const pageIntro = typeof data?.pageIntro === 'string' ? data.pageIntro.trim() : ''
    const pageTitle = typeof data?.pageTitle === 'string' ? data.pageTitle.trim() : ''
    const metaDescription = typeof data?.metaDescription === 'string' ? data.metaDescription.trim() : ''
    const canonicalUrl = typeof data?.canonicalUrl === 'string' ? data.canonicalUrl.trim() : ''
    const robotsMeta = typeof data?.robotsMeta === 'string' ? data.robotsMeta.trim() : ''

    if (pageHeadingEl && pageHeading.length > 0) pageHeadingEl.textContent = pageHeading
    if (pageIntroEl && pageIntro.length > 0) pageIntroEl.textContent = pageIntro
    if (pageTitle.length > 0) document.title = `${pageTitle} - MAC`

    const descriptionMeta = document.querySelector<HTMLMetaElement>('meta[name="description"]')
    if (descriptionMeta) {
        if (metaDescription.length > 0) descriptionMeta.setAttribute('content', metaDescription)
        else descriptionMeta.removeAttribute('content')
    }

    const canonicalLink = document.querySelector<HTMLLinkElement>('link[rel="canonical"]')
    if (canonicalLink && canonicalUrl.length > 0) canonicalLink.setAttribute('href', canonicalUrl)

    let robotsTag = document.querySelector<HTMLMetaElement>('meta[name="robots"]')
    if (robotsMeta.length > 0) {
        if (!robotsTag) {
            robotsTag = document.createElement('meta')
            robotsTag.setAttribute('name', 'robots')
            document.head.appendChild(robotsTag)
        }

        robotsTag.setAttribute('content', robotsMeta)
    } else {
        robotsTag?.remove()
    }
}

async function getModels(make: string, baseParams?: URLSearchParams) {
    const params = new URLSearchParams(baseParams?.toString() ?? getFilterQueryParams().toString())
    params.set('handler', 'Models')
    params.set('scopeMake', make)
    const response = await fetch('/cars-for-sale?' + params.toString())
    let data = (await response.json()) as Array<{ make: string, model: string, count: number }>

    return data;
}

async function getTrims(make: string, model: string, baseParams?: URLSearchParams) {
    const params = new URLSearchParams(baseParams?.toString() ?? getFilterQueryParams().toString())
    params.set('handler', 'Trims')
    params.set('scopeMake', make)
    params.set('scopeModel', model)
    const response = await fetch('/cars-for-sale?' + params.toString())
    let data = (await response.json()) as Array<{ make: string, model: string, trim: string, count: number }>

    return data;
}

async function handleMakeChange(cb: HTMLInputElement, data: any, queryParams?: URLSearchParams) {
    if (cb.checked && data) {
        let make = cb.value
        let models = await getModels(make, queryParams)
        const getValue = (item: any, ...keys: string[]) => {
            for (const key of keys) {
                if (item?.[key] !== undefined && item?.[key] !== null) return item[key]
            }

            return ''
        }
        const getCount = (item: any) => {
            const value = getValue(item, 'count', 'Count')
            return Number.isFinite(Number(value)) ? Number(value) : 0
        }

        // Get model HTML
        let html = `<div class='model-data ps-3 hidden peer-checked:block'>`

        for (let z = 0; z < models?.length; z++) {
            const modelName = String(getValue(models[z], 'model', 'Model'))
            const uniqueId = `${make}-${modelName}`.replace(/\W+/g, '')
            const matchingCount = getCount(models[z])

            html += getLIItem(make, modelName, uniqueId, matchingCount, 'Model')
        }

        html += `</div>`

        cb.parentElement?.insertAdjacentHTML('beforeend', html)
    }
    else {
        // Remove from DOM
        cb.parentElement?.querySelectorAll('.model-data')?.forEach(item => item.remove())
    }
}

async function handleModelChange(cb: HTMLInputElement, data: any, queryParams?: URLSearchParams) {
    let make = cb.getAttribute('data-make') as string
    let model = cb.value

    if (cb.checked && data) {
        let trims = await getTrims(make, model, queryParams)
        const getValue = (item: any, ...keys: string[]) => {
            for (const key of keys) {
                if (item?.[key] !== undefined && item?.[key] !== null) return item[key]
            }

            return ''
        }
        const getCount = (item: any) => {
            const value = getValue(item, 'count', 'Count')
            return Number.isFinite(Number(value)) ? Number(value) : 0
        }
        let html = `<div class='trim-data ps-8 pt-3 hidden peer-checked:block'>
                    <div class="mb-2 text-xs font-semibold uppercase tracking-[0.08em] text-gray">Trim</div>
                    <div class="grid grid-cols-1 gap-y-3">`

        for (let z = 0; z < trims?.length ; z++) {
            const trimName = String(getValue(trims[z], 'trim', 'Trim'))
            let uniqueId = `${make}-${model}-${trimName}`.replace(/\W+/g, '')

            html += getTrimLIItem(make, model, trimName, uniqueId, getCount(trims[z]))
        }

        html += `</div></div>`

        cb.parentElement?.querySelectorAll('.trim-data').forEach(item => item.remove())
        cb.parentElement?.insertAdjacentHTML('beforeend', html)
    }
    else {
        // Remove from DOM
        cb.parentElement?.querySelectorAll('.trim-data')?.forEach(item => item.remove())
    }
}

const getLIItem = (make: string, value: string, uniqueId: string, count: number, name: string, model = '') => {
    const makeAttribute = make ? ` data-make="${make}"` : ''
    const modelAttribute = model ? ` data-model="${model}"` : ''
    let html = `<div class="pt-1 cursor-pointer" data-filter-option data-filter-name="${name}" data-filter-value="${value}">
            <input type="checkbox" name="${name}" data-make="${make}"${model ? ` data-model="${model}"` : ''} value="${value}" id="filter-car-${name}-${uniqueId}" class="hidden peer" />
            <label for="filter-car-${name}-${uniqueId}" class="relative flex items-center gap-4 after:w-6 after:h-6 after:border after:border-blue-2 after:rounded-md after:bg-blue-2 after:absolute after:top-1/2 after:-translate-y-1/2 after:left-0 after:bg-white-check after:bg-no-repeat after:bg-center after:bg-cover after:transition duration-300 after:opacity-0 peer-checked:after:opacity-100">
                <span class="w-6 h-6 block border border-gray-2 rounded-md bg-white"></span>
                <span class="flex-1">${value} <span data-name="${name}" data-value="${value}"${makeAttribute}${modelAttribute} class="italic text-sky-400">(${count ?? 0})</span></span>
            </label>
        </div>`

    return html
}

const getTrimLIItem = (make: string, model: string, value: string, uniqueId: string, count: number) => {
    return `<div class="trim-item relative" data-make="${make}" data-model="${model}" data-filter-option data-filter-name="Trim" data-filter-value="${value}">
            <input type="checkbox" name="Trim" data-make="${make}" data-model="${model}" value="${value}" id="filter-car-Trim-${uniqueId}" class="hidden peer" />
            <label for="filter-car-Trim-${uniqueId}" class="relative flex items-center gap-4 after:w-6 after:h-6 after:border after:border-blue-2 after:rounded-md after:bg-blue-2 after:absolute after:top-1/2 after:-translate-y-1/2 after:left-0 after:bg-white-check after:bg-no-repeat after:bg-center after:bg-cover after:transition duration-300 after:opacity-0 peer-checked:after:opacity-100">
                <span class="w-6 h-6 block border border-gray-2 rounded-md bg-white"></span>
                <span class="flex-1">${value} <span data-name="Trim" data-value="${value}" data-make="${make}" data-model="${model}" class="italic text-sky-400">(${count ?? 0})</span></span>
            </label>
        </div>`
}

function toggleFilterOptionsVisibility() {
    document.querySelectorAll<HTMLElement>('[data-filter-option]').forEach(optionEl => {
        optionEl.classList.remove('hidden')
    })
}

function toggleNoResults(count: number) {
    document.body.classList.toggle('no-cars', count == 0)
}

function formatCurrency(value: string | number) {
    return '$' + Number(value).toLocaleString()
}

function escapeSelector(value: string) {
    return typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
        ? CSS.escape(value)
        : value.replace(/"/g, '\\"')
}

function setSyncedTargets(selectors: string | null, value: string) {
    if (!selectors) return

    document.querySelectorAll<HTMLElement>(selectors).forEach(syncEl => {
        if (syncEl instanceof HTMLInputElement || syncEl instanceof HTMLTextAreaElement || syncEl instanceof HTMLSelectElement) {
            syncEl.value = value
        } else {
            syncEl.innerHTML = value
        }
    })
}

function setInputValue(input: HTMLInputElement | HTMLSelectElement | null, value: string) {
    if (!input) return

    input.value = value

    if (input instanceof HTMLInputElement) {
        setSyncedTargets(input.getAttribute('data-syncfield'), value)
        input.dispatchEvent(new Event('input', { bubbles: true }))
    }
}

function getInputTextValue(selector: string) {
    return (document.querySelector<HTMLInputElement>(selector)?.value ?? '').trim()
}

function getNumericInputValue(selector: string) {
    const value = getInputTextValue(selector)
    return value.length > 0 ? Number(value) : null
}

function getSelectedPaymentTerm() {
    return document.querySelector<HTMLInputElement>('#filters-form input[name="payment-term-selector"]:checked')?.value ?? ''
}

function getActivePaymentTerm() {
    return getSelectedPaymentTerm() || getInputTextValue('#filters-form input[name="PaymentTerm"]')
}

function getRangeSummary(minValue: string, maxValue: string, suffix = '') {
    if (minValue && maxValue) return `${minValue}-${maxValue}${suffix}`
    if (minValue) return `${minValue}${suffix}+`
    if (maxValue) return `Up to ${maxValue}${suffix}`
    return ''
}

function collapseList(values: string[], maxItems = 3) {
    if (values.length <= maxItems) return values.join(', ')
    return `${values.slice(0, maxItems).join(', ')} +${values.length - maxItems} more`
}

function getPaymentSummaryText() {
    const parts: string[] = []
    const rate = getInputTextValue('#custom-apr-display')
    const downPayment = getNumericInputValue('#payment-cashdown-display')
    const term = getActivePaymentTerm()
    const paymentMin = getInputTextValue('#filters-form input[name="PaymentMin"]')
    const paymentMax = getInputTextValue('#filters-form input[name="PaymentMax"]')

    if (rate) parts.push(`${Number(rate)}% APR`)
    if (term) parts.push(`${term} mo`)
    if (downPayment && downPayment > 0) parts.push(`${formatCurrency(String(downPayment))} down`)

    const paymentRange = getRangeSummary(
        paymentMin ? formatCurrency(paymentMin) : '',
        paymentMax ? formatCurrency(paymentMax) : '',
        '/mo')

    if (paymentRange) parts.push(paymentRange)

    return collapseList(parts, 4)
}

function buildAppliedFilterChips() {
    const chips: AppliedFilterChip[] = []

    const checkedInputs = (name: string) => Array
        .from(document.querySelectorAll<HTMLInputElement>(`#filters-form input[name="${name}"]:checked`))

    const getInput = (selector: string) => document.querySelector<HTMLInputElement>(selector)
    const getSelect = (selector: string) => document.querySelector<HTMLSelectElement>(selector)
    const getValue = (selector: string) => getInputTextValue(selector)
    const pushCheckboxChips = (name: string) => {
        checkedInputs(name).forEach(input => {
            chips.push({ field: name, label: input.value, value: input.value })
        })
    }

    const zip = getValue('#filters-form input[name="Zip"]')
    if (zip) chips.push({ field: 'Zip', label: `ZIP ${zip}` })

    const paymentFiltersAreActive = hasFinanceRate()

    const paymentMin = getValue('#filters-form input[name="PaymentMin"]')
    if (paymentFiltersAreActive && paymentMin && Number(paymentMin) > 0) {
        chips.push({ field: 'PaymentMin', label: `Min ${formatCurrency(paymentMin)}/mo` })
    }

    const paymentMax = getValue('#filters-form input[name="PaymentMax"]')
    if (paymentFiltersAreActive && paymentMax && Number(paymentMax) > 0) {
        chips.push({ field: 'PaymentMax', label: `Max ${formatCurrency(paymentMax)}/mo` })
    }

    pushCheckboxChips('Condition')

    const yearMinEl = getInput('#filters-form input[name="YearMin"]')
    const yearMaxEl = getInput('#filters-form input[name="YearMax"]')
    if (yearMinEl?.value && yearMinEl.value !== yearMinEl.min) {
        chips.push({ field: 'YearMin', label: `Year ${yearMinEl.value}+` })
    }

    if (yearMaxEl?.value && yearMaxEl.value !== yearMaxEl.max) {
        chips.push({ field: 'YearMax', label: `Year up to ${yearMaxEl.value}` })
    }

    const priceMin = getValue('#filters-form input[name="PriceMin"]')
    if (priceMin && Number(priceMin) > 0) chips.push({ field: 'PriceMin', label: `Price ${formatCurrency(priceMin)}+` })

    const priceMax = getValue('#filters-form input[name="PriceMax"]')
    if (priceMax && Number(priceMax) > 0) chips.push({ field: 'PriceMax', label: `Price up to ${formatCurrency(priceMax)}` })

    const mileageSelect = getSelect('#filters-form select[name="MileageMax"]')
    if (mileageSelect?.value) {
        chips.push({
            field: 'MileageMax',
            label: mileageSelect.options[mileageSelect.selectedIndex]?.textContent?.trim() ?? mileageSelect.value
        })
    }

    pushCheckboxChips('BodyType')

    checkedInputs('Make').forEach(input => {
        chips.push({ field: 'Make', label: input.value, value: input.value, make: input.value })
    })

    checkedInputs('Model').forEach(input => {
        chips.push({
            field: 'Model',
            label: input.value,
            value: input.value,
            make: input.getAttribute('data-make') ?? '',
            model: input.value
        })
    })

    checkedInputs('Trim').forEach(input => {
        const trimItem = input.closest<HTMLElement>('.trim-item')
        chips.push({
            field: 'Trim',
            label: input.value,
            value: input.value,
            make: trimItem?.getAttribute('data-make') ?? '',
            model: trimItem?.getAttribute('data-model') ?? ''
        })
    })

    pushCheckboxChips('Color')
    pushCheckboxChips('Drivetrain')
    pushCheckboxChips('EngineFuelType')
    pushCheckboxChips('Transmission')

    return chips
}

function updateAppliedFilterChips() {
    if (!appliedFiltersRowEl || !appliedFiltersListEl || !clearAllFiltersEl) return

    const chips = buildAppliedFilterChips()
    appliedFiltersListEl.innerHTML = ''

    chips.forEach(chip => {
        const button = document.createElement('button')
        button.type = 'button'
        button.className = 'inline-flex items-center gap-2 rounded-full border border-gray-2 bg-gray-3 px-3 py-1.5 text-sm font-medium text-maincolor hover:border-secondarycolor hover:text-secondarycolor'
        button.setAttribute('data-filter-chip-remove', 'true')
        button.setAttribute('data-field', chip.field)

        if (chip.value) button.setAttribute('data-value', chip.value)
        if (chip.make) button.setAttribute('data-make', chip.make)
        if (chip.model) button.setAttribute('data-model', chip.model)

        button.innerHTML = `<span>${chip.label}</span><span aria-hidden="true" class="text-base leading-none">&times;</span>`
        appliedFiltersListEl.appendChild(button)
    })

    const hasChips = chips.length > 0
    appliedFiltersRowEl.classList.toggle('hidden', !hasChips)
    clearAllFiltersEl.classList.toggle('hidden', !hasChips)
}

function clearModelSelectionsForMake(make: string) {
    const makeSelector = escapeSelector(make)
    document.querySelectorAll<HTMLInputElement>(`#filters-form input[name="Model"][data-make="${makeSelector}"]`).forEach(input => {
        input.checked = false
    })
}

function clearTrimSelectionsForMake(make: string) {
    const makeSelector = escapeSelector(make)
    document.querySelectorAll<HTMLInputElement>(`.trim-item[data-make="${makeSelector}"] input[name="Trim"]`).forEach(input => {
        input.checked = false
    })
}

function clearTrimSelectionsForModel(make: string, model: string) {
    const makeSelector = escapeSelector(make)
    const modelSelector = escapeSelector(model)
    document.querySelectorAll<HTMLInputElement>(`.trim-item[data-make="${makeSelector}"][data-model="${modelSelector}"] input[name="Trim"]`).forEach(input => {
        input.checked = false
    })
}

function clearAllShopperFilters() {
    setInputValue(document.querySelector<HTMLInputElement>('#filters-form input[name="Zip"]'), '')
    setInputValue(financeRateInputEl, '')
    setInputValue(document.getElementById('payment-cashdown-display') as HTMLInputElement | null, '0')
    setInputValue(document.querySelector<HTMLInputElement>('#filters-form input[name="PaymentMin"]'), '')
    setInputValue(document.querySelector<HTMLInputElement>('#filters-form input[name="PaymentMax"]'), '')
    setInputValue(document.querySelector<HTMLInputElement>('#filters-form input[name="PriceMin"]'), '')
    setInputValue(document.querySelector<HTMLInputElement>('#filters-form input[name="PriceMax"]'), '')

    const yearMinEl = document.querySelector<HTMLInputElement>('#filters-form input[name="YearMin"]')
    const yearMaxEl = document.querySelector<HTMLInputElement>('#filters-form input[name="YearMax"]')
    setInputValue(yearMinEl, yearMinEl?.min ?? '')
    setInputValue(yearMaxEl, yearMaxEl?.max ?? '')

    const mileageSelect = document.querySelector<HTMLSelectElement>('#filters-form select[name="MileageMax"]')
    if (mileageSelect) mileageSelect.value = ''

    document.querySelectorAll<HTMLInputElement>('#filters-form input[name="payment-term-selector"]').forEach(input => {
        input.checked = false
    })
    setSyncedTargets('#InventoryFilters_PaymentTerm,.term', '')

    document.querySelectorAll<HTMLInputElement>('#filters-form input[type="checkbox"]').forEach(input => {
        input.checked = false
    })
}

async function removeAppliedFilterChip(chipButton: HTMLElement) {
    const field = chipButton.getAttribute('data-field') ?? ''
    const value = chipButton.getAttribute('data-value') ?? ''
    const make = chipButton.getAttribute('data-make') ?? ''
    const model = chipButton.getAttribute('data-model') ?? ''
    let changedInput: HTMLInputElement | null = null

    switch (field) {
        case 'Zip':
            setInputValue(document.querySelector<HTMLInputElement>('#filters-form input[name="Zip"]'), '')
            break
        case 'CustomAPR':
            setInputValue(financeRateInputEl, '')
            break
        case 'PaymentCashDown':
            setInputValue(document.getElementById('payment-cashdown-display') as HTMLInputElement | null, '0')
            break
        case 'PaymentMin':
        case 'PaymentMax':
        case 'PriceMin':
        case 'PriceMax':
            setInputValue(document.querySelector<HTMLInputElement>(`#filters-form input[name="${field}"]`), '')
            break
        case 'PaymentTerm':
            document.querySelectorAll<HTMLInputElement>('#filters-form input[name="payment-term-selector"]').forEach(input => {
                input.checked = false
            })
            setSyncedTargets('#InventoryFilters_PaymentTerm,.term', '')
            break
        case 'YearMin': {
            const input = document.querySelector<HTMLInputElement>('#filters-form input[name="YearMin"]')
            setInputValue(input, input?.min ?? '')
            break
        }
        case 'YearMax': {
            const input = document.querySelector<HTMLInputElement>('#filters-form input[name="YearMax"]')
            setInputValue(input, input?.max ?? '')
            break
        }
        case 'MileageMax': {
            const select = document.querySelector<HTMLSelectElement>('#filters-form select[name="MileageMax"]')
            if (select) select.value = ''
            break
        }
        case 'Make': {
            changedInput = document.querySelector<HTMLInputElement>(`#filters-form input[name="Make"][value="${escapeSelector(value)}"]`)
            if (changedInput) changedInput.checked = false
            clearModelSelectionsForMake(make || value)
            clearTrimSelectionsForMake(make || value)
            break
        }
        case 'Model': {
            changedInput = document.querySelector<HTMLInputElement>(`#filters-form input[name="Model"][data-make="${escapeSelector(make)}"][value="${escapeSelector(value)}"]`)
            if (changedInput) changedInput.checked = false
            clearTrimSelectionsForModel(make, model || value)
            break
        }
        case 'Trim': {
            changedInput = document.querySelector<HTMLInputElement>(`.trim-item[data-make="${escapeSelector(make)}"][data-model="${escapeSelector(model)}"] input[name="Trim"][value="${escapeSelector(value)}"]`)
            if (changedInput) changedInput.checked = false
            break
        }
        default: {
            changedInput = document.querySelector<HTMLInputElement>(`#filters-form input[name="${field}"][value="${escapeSelector(value)}"]`)
            if (changedInput) changedInput.checked = false
            break
        }
    }

    if (typeof posthog !== 'undefined') {
        posthog.capture('filter_cleared', { filter_type: field || 'unknown' });
    }

    updateFilterSummaries()
    updateAppliedFilterChips()
    await refreshData(changedInput, { skipFinanceRatePrompt: true })
}

function updateFilterSummaries() {
    const setSummary = (key: string, text: string) => {
        const el = document.querySelector<HTMLElement>(`[data-filter-summary="${key}"]`)
        if (!el) return

        const summaryText = text.trim()
        el.textContent = summaryText
        el.classList.toggle('hidden', summaryText.length === 0)
    }

    const checkedValues = (name: string) => Array
        .from(document.querySelectorAll<HTMLInputElement>(`#filters-form input[name="${name}"]:checked`))
        .map(input => input.value.trim())
        .filter(value => value.length > 0)

    const yearMinEl = document.querySelector<HTMLInputElement>('#filters-form input[name="YearMin"]')
    const yearMaxEl = document.querySelector<HTMLInputElement>('#filters-form input[name="YearMax"]')
    const defaultYearMin = yearMinEl?.min ?? ''
    const defaultYearMax = yearMaxEl?.max ?? ''
    const yearMin = (yearMinEl?.value ?? '').trim()
    const yearMax = (yearMaxEl?.value ?? '').trim()

    const priceMin = getInputTextValue('#filters-form input[name="PriceMin"]')
    const priceMax = getInputTextValue('#filters-form input[name="PriceMax"]')
    const mileageSelect = document.querySelector<HTMLSelectElement>('#filters-form select[name="MileageMax"]')
    const mileageSummary = mileageSelect && mileageSelect.value
        ? mileageSelect.options[mileageSelect.selectedIndex]?.textContent?.trim() ?? ''
        : ''

    const priceSummary = getRangeSummary(
        priceMin ? formatCurrency(priceMin) : '',
        priceMax ? formatCurrency(priceMax) : '')

    const yearSummary = getRangeSummary(
        yearMin && yearMin !== defaultYearMin ? yearMin : '',
        yearMax && yearMax !== defaultYearMax ? yearMax : '')

    const makeModelValues = [...checkedValues('Make'), ...checkedValues('Model')]

    setSummary('payment', getPaymentSummaryText())
    setSummary('price', priceSummary)
    setSummary('condition', collapseList(checkedValues('Condition')))
    setSummary('year', yearSummary)
    setSummary('body-type', collapseList(checkedValues('BodyType')))
    setSummary('make-model', collapseList(makeModelValues, 4))
    setSummary('trim', collapseList(checkedValues('Trim')))
    setSummary('color', collapseList(checkedValues('Color')))
    setSummary('mileage', mileageSummary)
    setSummary('drivetrain', collapseList(checkedValues('Drivetrain')))
    setSummary('engine-fuel', collapseList(checkedValues('EngineFuelType')))
    setSummary('transmission', collapseList(checkedValues('Transmission')))
}

function hasFinanceRate() {
    const rateValue = financeRateInputEl?.value?.trim() ?? ''
    return rateValue.length > 0 && Number(rateValue) > 0
}

function setFinanceRateRequiredState(show: boolean) {
    financeRateRequiredEl?.classList.toggle('hidden', !show)
    financeRateLabelEl?.classList.toggle('text-red', show)

    if (financeRateInputEl) {
        financeRateInputEl.style.outlineColor = show ? '#ff4458' : ''
    }
}

function requiresFinanceRatePrompt(input: HTMLInputElement | HTMLSelectElement | null) {
    if (!input) return false

    return input.id === 'payment-cashdown-display'
        || input.name === 'PaymentMin'
        || input.name === 'PaymentMax'
        || input.name === 'payment-term-selector'
}

function toggleYearSection() {
    let isNewChecked = document.querySelector('input[name=Condition][value=New]:checked') != null
    let isUsedChecked = document.querySelector('input[name=Condition][value=Used]:checked') != null

    yearSectionEl?.classList.toggle('hidden', isNewChecked && !isUsedChecked)
}

financeRateInputEl?.addEventListener('input', () => {
    if (hasFinanceRate()) {
        setFinanceRateRequiredState(false)
    }

    updateFilterSummaries()
    updateAppliedFilterChips()
})
